import { ReactNode } from 'react';
import useCheckoutBoxStyles from './CheckoutBox.styles';
import { mergeClasses } from '@fluentui/react-components';
import HorizontalLine from '../HorizontalLine/HorizontalLine';

export interface ICheckoutBoxProps {
    header?: string;
    className?: string;
    children?: ReactNode;
}
const CheckoutBox = (props: ICheckoutBoxProps) => {
    const { header, className, children } = props;
    const styles = useCheckoutBoxStyles();

    return (
        <div className={mergeClasses(styles.container, className)}>
            {header && (
                <>
                    <h2 className={styles.subheader}>{header}</h2>

                    <HorizontalLine className={styles.hr} />
                </>
            )}
            {children}
        </div>
    );
};

export default CheckoutBox;
